import {FC, PropsWithChildren} from "react";
import {
  ScriptDefinition,
  ScriptLoader,
  ScriptPlaceholderProps
} from "../script-injector";
import {WebComponent, WebComponentProps} from "./WebComponent";

// prettier-ignore
export interface WebComponentLoaderProps
    extends WebComponentProps, ScriptPlaceholderProps {
  script: ScriptDefinition;
}

export const WebComponentLoader: FC<
  PropsWithChildren<WebComponentLoaderProps>
> = ({
  script,
  loading,
  failure,
  element,
  attributes,
  placeholder,
  children
}) => {
  return (
    <ScriptLoader
      id={script.id}
      source={script.source}
      async={script.async}
      defer={script.defer}
      loading={loading}
      failure={failure}>
      <WebComponent
        element={element}
        attributes={attributes}
        placeholder={placeholder}>
        {children}
      </WebComponent>
    </ScriptLoader>
  );
};
